import React from 'react';
import { Users, MessageSquare, GitBranch, BarChart2, UserCheck, Clock, Calendar, Activity, FileText, Briefcase, Globe } from 'lucide-react';
const translations = {
  en: {
    title: 'AI Hiring Assistant Dashboard',
    overview: 'Overview',
    activeChats: 'Active Chats',
    completedApplications: 'Completed Applications',
    activeWorkflows: 'Active Workflows',
    avgResponseTime: 'Avg. Response Time',
    candidatesScreened: 'Candidates Screened',
    interviews: 'Interviews Scheduled',
    chatbot: 'Chatbot Performance',
    messages: 'Messages',
    responseRate: 'Response Rate',
    satisfaction: 'User Satisfaction',
    languages: 'Languages',
    english: 'English',
    german: 'German',
    french: 'French',
    italian: 'Italian',
    workflows: 'Workflow Activity',
    newCandidate: 'New Candidate Processing',
    interviewScheduling: 'Interview Scheduling',
    documentVerification: 'Document Verification',
    candidateFollowup: 'Candidate Follow-up',
    recentActivity: 'Recent Activity',
    activities: ['New application received for Software Engineer position', 'Interview scheduled with Anna Meyer for Marketing Manager', 'CV verification completed for Thomas Weber', "Follow-up email sent to candidates from last week's job fair", 'New job posting automated for Senior Developer position'],
    jobPositions: 'Open Job Positions',
    positions: [{
      title: 'Software Engineer',
      department: 'Engineering',
      applications: 24
    }, {
      title: 'Marketing Manager',
      department: 'Marketing',
      applications: 18
    }, {
      title: 'Sales Representative',
      department: 'Sales',
      applications: 31
    }, {
      title: 'Product Designer',
      department: 'Design',
      applications: 15
    }]
  },
  de: {
    title: 'KI-Einstellungsassistent Dashboard',
    overview: 'Überblick',
    activeChats: 'Aktive Chats',
    completedApplications: 'Abgeschlossene Bewerbungen',
    activeWorkflows: 'Aktive Workflows',
    avgResponseTime: 'Durchschn. Antwortzeit',
    candidatesScreened: 'Geprüfte Kandidaten',
    interviews: 'Geplante Interviews',
    chatbot: 'Chatbot-Leistung',
    messages: 'Nachrichten',
    responseRate: 'Antwortrate',
    satisfaction: 'Benutzerzufriedenheit',
    languages: 'Sprachen',
    english: 'Englisch',
    german: 'Deutsch',
    french: 'Französisch',
    italian: 'Italienisch',
    workflows: 'Workflow-Aktivität',
    newCandidate: 'Neue Kandidatenverarbeitung',
    interviewScheduling: 'Terminplanung für Vorstellungsgespräche',
    documentVerification: 'Dokumentenprüfung',
    candidateFollowup: 'Kandidaten-Nachverfolgung',
    recentActivity: 'Neueste Aktivitäten',
    activities: ['Neue Bewerbung für die Position als Software-Ingenieur eingegangen', 'Vorstellungsgespräch mit Anna Meyer für Marketing Manager geplant', 'Lebenslaufprüfung für Thomas Weber abgeschlossen', 'Follow-up-E-Mail an Kandidaten von der Jobmesse der letzten Woche gesendet', 'Neue Stellenausschreibung für Senior Developer automatisiert'],
    jobPositions: 'Offene Stellenangebote',
    positions: [{
      title: 'Software-Ingenieur',
      department: 'Engineering',
      applications: 24
    }, {
      title: 'Marketing Manager',
      department: 'Marketing',
      applications: 18
    }, {
      title: 'Vertriebsmitarbeiter',
      department: 'Vertrieb',
      applications: 31
    }, {
      title: 'Produktdesigner',
      department: 'Design',
      applications: 15
    }]
  },
  fr: {
    title: "Tableau de bord de l'assistant de recrutement IA",
    overview: 'Aperçu',
    activeChats: 'Chats actifs',
    completedApplications: 'Candidatures complétées',
    activeWorkflows: 'Flux de travail actifs',
    avgResponseTime: 'Temps de réponse moyen',
    candidatesScreened: 'Candidats examinés',
    interviews: 'Entretiens programmés',
    chatbot: 'Performance du chatbot',
    messages: 'Messages',
    responseRate: 'Taux de réponse',
    satisfaction: 'Satisfaction utilisateur',
    languages: 'Langues',
    english: 'Anglais',
    german: 'Allemand',
    french: 'Français',
    italian: 'Italien',
    workflows: 'Activité des flux de travail',
    newCandidate: 'Traitement des nouveaux candidats',
    interviewScheduling: "Planification d'entretiens",
    documentVerification: 'Vérification des documents',
    candidateFollowup: 'Suivi des candidats',
    recentActivity: 'Activité récente',
    activities: ["Nouvelle candidature reçue pour le poste d'ingénieur logiciel", 'Entretien programmé avec Anna Meyer pour le poste de responsable marketing', 'Vérification du CV terminée pour Thomas Weber', "E-mail de suivi envoyé aux candidats du salon de l'emploi de la semaine dernière", "Nouvelle offre d'emploi automatisée pour le poste de développeur senior"],
    jobPositions: 'Postes ouverts',
    positions: [{
      title: 'Ingénieur logiciel',
      department: 'Ingénierie',
      applications: 24
    }, {
      title: 'Responsable marketing',
      department: 'Marketing',
      applications: 18
    }, {
      title: 'Représentant commercial',
      department: 'Ventes',
      applications: 31
    }, {
      title: 'Designer produit',
      department: 'Design',
      applications: 15
    }]
  },
  it: {
    title: "Dashboard dell'assistente di assunzione AI",
    overview: 'Panoramica',
    activeChats: 'Chat attive',
    completedApplications: 'Candidature completate',
    activeWorkflows: 'Flussi di lavoro attivi',
    avgResponseTime: 'Tempo medio di risposta',
    candidatesScreened: 'Candidati esaminati',
    interviews: 'Colloqui programmati',
    chatbot: 'Prestazioni del chatbot',
    messages: 'Messaggi',
    responseRate: 'Tasso di risposta',
    satisfaction: 'Soddisfazione utente',
    languages: 'Lingue',
    english: 'Inglese',
    german: 'Tedesco',
    french: 'Francese',
    italian: 'Italiano',
    workflows: 'Attività dei flussi di lavoro',
    newCandidate: 'Elaborazione nuovi candidati',
    interviewScheduling: 'Pianificazione colloqui',
    documentVerification: 'Verifica documenti',
    candidateFollowup: 'Follow-up candidati',
    recentActivity: 'Attività recente',
    activities: ['Nuova candidatura ricevuta per la posizione di Ingegnere Software', 'Colloquio programmato con Anna Meyer per Responsabile Marketing', 'Verifica CV completata per Thomas Weber', 'Email di follow-up inviata ai candidati della fiera del lavoro della scorsa settimana', 'Nuova offerta di lavoro automatizzata per la posizione di Sviluppatore Senior'],
    jobPositions: 'Posizioni aperte',
    positions: [{
      title: 'Ingegnere Software',
      department: 'Ingegneria',
      applications: 24
    }, {
      title: 'Responsabile Marketing',
      department: 'Marketing',
      applications: 18
    }, {
      title: 'Rappresentante Vendite',
      department: 'Vendite',
      applications: 31
    }, {
      title: 'Designer di Prodotto',
      department: 'Design',
      applications: 15
    }]
  }
};
export function Dashboard({
  language
}) {
  const t = translations[language];
  const languagePercentages = {
    en: 45,
    de: 30,
    fr: 15,
    it: 10
  };
  const workflowData = [{
    name: t.newCandidate,
    value: 42,
    color: 'bg-blue-500'
  }, {
    name: t.interviewScheduling,
    value: 28,
    color: 'bg-green-500'
  }, {
    name: t.documentVerification,
    value: 18,
    color: 'bg-purple-500'
  }, {
    name: t.candidateFollowup,
    value: 12,
    color: 'bg-orange-500'
  }];
  return <div className="container mx-auto px-4 py-6" data-id="element-189">
      {/* Dashboard Header */}
      <h1 className="text-2xl font-bold text-gray-800 mb-6" data-id="element-190">{t.title}</h1>
      {/* Overview Cards */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-6 gap-4 mb-6" data-id="element-191">
        <div className="bg-white p-4 rounded-lg shadow-sm border border-gray-100" data-id="element-192">
          <div className="flex items-center space-x-2 text-blue-600 mb-2" data-id="element-193">
            <MessageSquare size={18} data-id="element-194" />
            <span className="text-sm font-medium text-gray-600" data-id="element-195">
              {t.activeChats}
            </span>
          </div>
          <p className="text-2xl font-bold" data-id="element-196">24</p>
        </div>
        <div className="bg-white p-4 rounded-lg shadow-sm border border-gray-100" data-id="element-197">
          <div className="flex items-center space-x-2 text-green-600 mb-2" data-id="element-198">
            <FileText size={18} data-id="element-199" />
            <span className="text-sm font-medium text-gray-600" data-id="element-200">
              {t.completedApplications}
            </span>
          </div>
          <p className="text-2xl font-bold" data-id="element-201">128</p>
        </div>
        <div className="bg-white p-4 rounded-lg shadow-sm border border-gray-100" data-id="element-202">
          <div className="flex items-center space-x-2 text-purple-600 mb-2" data-id="element-203">
            <GitBranch size={18} data-id="element-204" />
            <span className="text-sm font-medium text-gray-600" data-id="element-205">
              {t.activeWorkflows}
            </span>
          </div>
          <p className="text-2xl font-bold" data-id="element-206">8</p>
        </div>
        <div className="bg-white p-4 rounded-lg shadow-sm border border-gray-100" data-id="element-207">
          <div className="flex items-center space-x-2 text-orange-600 mb-2" data-id="element-208">
            <Clock size={18} data-id="element-209" />
            <span className="text-sm font-medium text-gray-600" data-id="element-210">
              {t.avgResponseTime}
            </span>
          </div>
          <p className="text-2xl font-bold" data-id="element-211">1.2s</p>
        </div>
        <div className="bg-white p-4 rounded-lg shadow-sm border border-gray-100" data-id="element-212">
          <div className="flex items-center space-x-2 text-indigo-600 mb-2" data-id="element-213">
            <UserCheck size={18} data-id="element-214" />
            <span className="text-sm font-medium text-gray-600" data-id="element-215">
              {t.candidatesScreened}
            </span>
          </div>
          <p className="text-2xl font-bold" data-id="element-216">215</p>
        </div>
        <div className="bg-white p-4 rounded-lg shadow-sm border border-gray-100" data-id="element-217">
          <div className="flex items-center space-x-2 text-teal-600 mb-2" data-id="element-218">
            <Calendar size={18} data-id="element-219" />
            <span className="text-sm font-medium text-gray-600" data-id="element-220">
              {t.interviews}
            </span>
          </div>
          <p className="text-2xl font-bold" data-id="element-221">42</p>
        </div>
      </div>
      {/* Main Dashboard Content */}
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6" data-id="element-222">
        {/* Chatbot Performance */}
        <div className="bg-white p-5 rounded-lg shadow-sm border border-gray-100" data-id="element-223">
          <div className="flex items-center justify-between mb-4" data-id="element-224">
            <h2 className="text-lg font-medium text-gray-800" data-id="element-225">{t.chatbot}</h2>
            <BarChart2 size={20} className="text-gray-400" data-id="element-226" />
          </div>
          <div className="space-y-4" data-id="element-227">
            <div data-id="element-228">
              <div className="flex justify-between mb-1" data-id="element-229">
                <span className="text-sm font-medium text-gray-600" data-id="element-230">
                  {t.messages}
                </span>
                <span className="text-sm font-medium text-gray-900" data-id="element-231">1,248</span>
              </div>
              <div className="w-full bg-gray-200 rounded-full h-2" data-id="element-232">
                <div className="bg-blue-600 h-2 rounded-full" style={{
                width: '85%'
              }} data-id="element-233"></div>
              </div>
            </div>
            <div data-id="element-234">
              <div className="flex justify-between mb-1" data-id="element-235">
                <span className="text-sm font-medium text-gray-600" data-id="element-236">
                  {t.responseRate}
                </span>
                <span className="text-sm font-medium text-gray-900" data-id="element-237">98.5%</span>
              </div>
              <div className="w-full bg-gray-200 rounded-full h-2" data-id="element-238">
                <div className="bg-green-600 h-2 rounded-full" style={{
                width: '98.5%'
              }} data-id="element-239"></div>
              </div>
            </div>
            <div data-id="element-240">
              <div className="flex justify-between mb-1" data-id="element-241">
                <span className="text-sm font-medium text-gray-600" data-id="element-242">
                  {t.satisfaction}
                </span>
                <span className="text-sm font-medium text-gray-900" data-id="element-243">92%</span>
              </div>
              <div className="w-full bg-gray-200 rounded-full h-2" data-id="element-244">
                <div className="bg-purple-600 h-2 rounded-full" style={{
                width: '92%'
              }} data-id="element-245"></div>
              </div>
            </div>
          </div>
          <div className="mt-6 border-t border-gray-100 pt-4" data-id="element-246">
            <h3 className="text-sm font-medium text-gray-700 mb-3" data-id="element-247">
              {t.languages}
            </h3>
            <div className="space-y-3" data-id="element-248">
              {Object.keys(languagePercentages).map(lang => {
              const langName = t[lang] || lang;
              return <div key={lang} data-id="element-249">
                    <div className="flex justify-between mb-1" data-id="element-250">
                      <span className="text-xs text-gray-600" data-id="element-251">{langName}</span>
                      <span className="text-xs text-gray-900" data-id="element-252">
                        {languagePercentages[lang]}%
                      </span>
                    </div>
                    <div className="w-full bg-gray-200 rounded-full h-1.5" data-id="element-253">
                      <div className={`h-1.5 rounded-full ${lang === 'en' ? 'bg-blue-500' : lang === 'de' ? 'bg-green-500' : lang === 'fr' ? 'bg-purple-500' : 'bg-orange-500'}`} style={{
                    width: `${languagePercentages[lang]}%`
                  }} data-id="element-254"></div>
                    </div>
                  </div>;
            })}
            </div>
          </div>
        </div>
        {/* Workflow Activity */}
        <div className="bg-white p-5 rounded-lg shadow-sm border border-gray-100" data-id="element-255">
          <div className="flex items-center justify-between mb-4" data-id="element-256">
            <h2 className="text-lg font-medium text-gray-800" data-id="element-257">{t.workflows}</h2>
            <Activity size={20} className="text-gray-400" data-id="element-258" />
          </div>
          <div className="space-y-4" data-id="element-259">
            {workflowData.map((workflow, index) => <div key={index} data-id="element-260">
                <div className="flex justify-between mb-1" data-id="element-261">
                  <span className="text-sm font-medium text-gray-600" data-id="element-262">
                    {workflow.name}
                  </span>
                  <span className="text-sm font-medium text-gray-900" data-id="element-263">
                    {workflow.value}%
                  </span>
                </div>
                <div className="w-full bg-gray-200 rounded-full h-2" data-id="element-264">
                  <div className={`${workflow.color} h-2 rounded-full`} style={{
                width: `${workflow.value}%`
              }} data-id="element-265"></div>
                </div>
              </div>)}
          </div>
          <div className="mt-6 pt-4 border-t border-gray-100" data-id="element-266">
            <div className="bg-blue-50 rounded-lg p-4" data-id="element-267">
              <div className="flex items-center space-x-2 mb-2" data-id="element-268">
                <GitBranch size={18} className="text-blue-600" data-id="element-269" />
                <h3 className="text-sm font-medium text-gray-700" data-id="element-270">
                  Workflow Efficiency
                </h3>
              </div>
              <div className="flex items-end space-x-2" data-id="element-271">
                <div className="text-3xl font-bold text-blue-700" data-id="element-272">78%</div>
                <div className="text-sm text-green-600 pb-1" data-id="element-273">
                  +12% vs. last month
                </div>
              </div>
              <p className="text-xs text-gray-500 mt-2" data-id="element-274">
                Average time saved across all automated workflows
              </p>
            </div>
          </div>
        </div>
        {/* Recent Activity */}
        <div className="bg-white p-5 rounded-lg shadow-sm border border-gray-100" data-id="element-275">
          <div className="flex items-center justify-between mb-4" data-id="element-276">
            <h2 className="text-lg font-medium text-gray-800" data-id="element-277">
              {t.recentActivity}
            </h2>
            <Clock size={20} className="text-gray-400" data-id="element-278" />
          </div>
          <div className="space-y-4" data-id="element-279">
            {t.activities.map((activity, index) => <div key={index} className="flex space-x-3 pb-3 border-b border-gray-100 last:border-0" data-id="element-280">
                <div className={`flex-shrink-0 w-8 h-8 rounded-full flex items-center justify-center ${index % 4 === 0 ? 'bg-blue-100 text-blue-600' : index % 4 === 1 ? 'bg-green-100 text-green-600' : index % 4 === 2 ? 'bg-purple-100 text-purple-600' : 'bg-orange-100 text-orange-600'}`} data-id="element-281">
                  {index % 4 === 0 ? <FileText size={16} data-id="element-282" /> : index % 4 === 1 ? <Calendar size={16} data-id="element-283" /> : index % 4 === 2 ? <UserCheck size={16} data-id="element-284" /> : <MessageSquare size={16} data-id="element-285" />}
                </div>
                <div data-id="element-286">
                  <p className="text-sm text-gray-700" data-id="element-287">{activity}</p>
                  <p className="text-xs text-gray-500 mt-1" data-id="element-288">
                    {index === 0 ? '10 minutes ago' : index === 1 ? '1 hour ago' : index === 2 ? '3 hours ago' : index === 3 ? 'Yesterday' : '2 days ago'}
                  </p>
                </div>
              </div>)}
          </div>
        </div>
      </div>
      {/* Open Job Positions */}
      <div className="mt-6" data-id="element-289">
        <div className="bg-white p-5 rounded-lg shadow-sm border border-gray-100" data-id="element-290">
          <div className="flex items-center justify-between mb-4" data-id="element-291">
            <h2 className="text-lg font-medium text-gray-800" data-id="element-292">
              {t.jobPositions}
            </h2>
            <Briefcase size={20} className="text-gray-400" data-id="element-293" />
          </div>
          <div className="overflow-x-auto" data-id="element-294">
            <table className="min-w-full divide-y divide-gray-200" data-id="element-295">
              <thead className="bg-gray-50" data-id="element-296">
                <tr data-id="element-297">
                  <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-298">
                    Title
                  </th>
                  <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-299">
                    Department
                  </th>
                  <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-300">
                    Applications
                  </th>
                  <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-301">
                    Status
                  </th>
                </tr>
              </thead>
              <tbody className="bg-white divide-y divide-gray-200" data-id="element-302">
                {t.positions.map((position, index) => <tr key={index} data-id="element-303">
                    <td className="px-6 py-4 whitespace-nowrap" data-id="element-304">
                      <div className="font-medium text-gray-900" data-id="element-305">
                        {position.title}
                      </div>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap" data-id="element-306">
                      <div className="text-sm text-gray-500" data-id="element-307">
                        {position.department}
                      </div>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap" data-id="element-308">
                      <div className="text-sm text-gray-900" data-id="element-309">
                        {position.applications}
                      </div>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap" data-id="element-310">
                      <span className={`px-2 inline-flex text-xs leading-5 font-semibold rounded-full ${index % 3 === 0 ? 'bg-green-100 text-green-800' : index % 3 === 1 ? 'bg-blue-100 text-blue-800' : 'bg-yellow-100 text-yellow-800'}`} data-id="element-311">
                        {index % 3 === 0 ? 'Active' : index % 3 === 1 ? 'Reviewing' : 'New'}
                      </span>
                    </td>
                  </tr>)}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>;
}